module.exports = "/_next/static/images/7a48386d7a380147cb4b03bba4f6113b-xpeer-fgts@0.5x.jpg";